<script setup lang="ts">
interface IProps {
	text: string;
}

defineProps<IProps>();
</script>

<template>
	<div class="input-amount-button">
		<template v-if="!$slots['default']">{{ text }}</template>
		<slot v-else />
	</div>
</template>

<style scoped lang="scss">
.input-amount-button {
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: var(--f7-theme-color);
	font-style: normal;
	font-weight: 500;
	font-size: 15px;
	line-height: 20px;
}
</style>
